export enum JobStatus {
  CompleteUploaded = "CompleteUploaded",
  CompleteInProgress = "CompleteInProgress",
  CompleteOffline = "CompleteOffline",
  CompletePending = "CompletePending",
  Upcoming = "Upcoming",
  Ready = "Ready",
  Overdue = "Overdue"
}
